import React from 'react';
import { Container, Card, CardGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getAllProducts } from '../../store/products';
import { FEATURED_GALLERY_IMAGES } from '../../constants';
import PageHeading from '../PageHeading';

class FeaturedProducts extends React.Component {
  componentDidMount() {
    this.props.getAllProducts();
  }

  render() {
    const products = this.props.products;
    const featured = Array.isArray(products)
      ? products.find((p) => p.name === 'H.O.T Cocoa') || products[0]
      : null;

    return (
      <Container className="Center-column featured-section">
        <hr className="featured-divider" />
        <PageHeading icon="star">Featured Product</PageHeading>
        <CardGroup className="featured-gallery">
          {FEATURED_GALLERY_IMAGES.map((image) => (
            <Card key={image.src} border="light" className="text-center marg">
              {featured ? (
                <Link to={'/product/' + featured.id}>
                  <Card.Img variant="top" src={image.src} alt={image.alt} />
                </Link>
              ) : (
                <Card.Img variant="top" src={image.src} alt={image.alt} />
              )}
            </Card>
          ))}
        </CardGroup>
        {featured && (
          <div className="featured-product-link">
            <Link to={'/product/' + featured.id}>
              <h2 className="featured-product-name">{featured.name}</h2>
              <p className="featured-product-price">${featured.price}</p>
            </Link>
          </div>
        )}
      </Container>
    );
  }
}

const mapState = (state) => ({
  products: state.products,
});

const mapDispatch = (dispatch) => ({
  getAllProducts: () => dispatch(getAllProducts()),
});

export default connect(mapState, mapDispatch)(FeaturedProducts);

FeaturedProducts.propTypes = {
  products: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getAllProducts: PropTypes.func,
};
